export const PHONE_DISPLAY = "+39 320 642 6787";
export const TEL_HREF = "tel:+393206426787";
export const WA_HREF_TEXT =
  "https://wa.me/393206426787?text=" +
  encodeURIComponent("Ciao! Vorrei prenotare un tavolo da La Cantina del Barone.");
export const WA_HREF_TEXT_EN =
  "https://wa.me/393206426787?text=" +
  encodeURIComponent("Hello! I'd like to book a table at La Cantina del Barone.");
export const SITE_URL = "https://www.lacantinadelbarone.it";
export const EMAIL_ADDRESS = "prenotazioni@lacantinadelbarone.it";
export const MAPS_EMBED =
  "https://www.google.com/maps?q=La%20Cantina%20del%20Barone%2C%20Cefal%C3%B9%20PA&output=embed";

export const LOGO_URL = "/logo.svg";

export const IMAGES = {
  hero: "https://customer-assets-lxgj4vgw.emergentagent.net/job_barone-wine-bar/artifacts/jt4nm207_IMG_3031.jpeg",
  about: "https://customer-assets-lxgj4vgw.emergentagent.net/job_barone-wine-bar/artifacts/cs34kgnm_IMG_3030.jpeg",
  alley: "https://images.pexels.com/photos/37900369/pexels-photo-37900369.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  sea: "https://customer-assets-lxgj4vgw.emergentagent.net/job_barone-wine-bar/artifacts/ho48y8nv_IMG_3032.jpeg",
  pairing: "https://customer-assets-lxgj4vgw.emergentagent.net/job_barone-wine-bar/artifacts/fsclev68_IMG_3029.jpeg",
};
